export enum Meridiem {
    AM = 'AM',
    PM = 'PM',
}

export const SECONDS_IN_MINUTE = 60;
